import React from 'react';
import PropTypes from 'prop-types';
import translations from 'utils/translations';

export const I18nContext = React.createContext();

export default class I18nProvider extends React.Component {
  static propTypes = {
    locale: PropTypes.string.isRequired,
    setLocale: PropTypes.func,
    children: PropTypes.node.isRequired,
  };
  static defaultProps = {
    locale: 'en',
  };

  static translatePhrase(phrase, locale) {
    if (locale !== 'en') {
      const phraseTranslations = translations[phrase];
      return (phraseTranslations && phraseTranslations[locale]) || phrase;
    }
    return phrase;
  }

  static getI18nTranslate(props) {
    const {locale} = props;
    return (phrases, ...params) => {
      let strings = '';
      const lastIdx = phrases.length - 1;
      for (let idx = 0; idx < lastIdx; ++idx) {
        strings +=
          I18nProvider.translatePhrase(phrases[idx], locale) + I18nProvider.translatePhrase(params[idx], locale);
      }
      return strings + I18nProvider.translatePhrase(phrases[lastIdx], locale);
    };
  }

  static getDerivedStateFromProps(props, state) {
    const {locale, setLocale} = props;
    return {
      ...state,
      locale,
      setLocale,
      isDefaultLanguage: locale === 'en',
      i18nTranslate: I18nProvider.getI18nTranslate(props),
    };
  }

  constructor(props) {
    super(props);
    this.state = I18nProvider.getDerivedStateFromProps(props, {});
  }

  render() {
    return <I18nContext.Provider value={this.state}>{this.props.children}</I18nContext.Provider>;
  }
}
